import _ from 'lodash';

const booleanFilterMethod = (filter, row) => {
  const {
    multiSelectValues,
    clearFilter,
  } = filter.value;
  if (clearFilter) {
    return true;
  }

  const rowValue = row[filter.id];

  return !!_.find(multiSelectValues, { value: rowValue });
};

export default booleanFilterMethod;
